import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { SubtleTagline } from '../styles';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const SupportTagline = props => {
  const {
    supportDetails: {
      isSupported,
      hasResources,
      partner,
      contact: {
        issueTrackerUrl,
        statusPageUrl,
        supportTicketSystemUrl,
        websiteUrl
      }
    }
  } = props;
  const taglineProps = {
    centered: true,
    as: 'h2'
  };
  const hasIssueTrackingResources = issueTrackerUrl || statusPageUrl || supportTicketSystemUrl || websiteUrl;
  if (partner.name && isSupported) {
    return /*#__PURE__*/_jsxs(SubtleTagline, _objectSpread(_objectSpread({}, taglineProps), {}, {
      children: [partner.name, " provides support for this app"]
    }));
  }
  if (hasResources || hasIssueTrackingResources) {
    return /*#__PURE__*/_jsx(SubtleTagline, _objectSpread(_objectSpread({}, taglineProps), {}, {
      children: "Basic support resources are available for this app."
    }));
  }
  return /*#__PURE__*/_jsx(SubtleTagline, _objectSpread(_objectSpread({}, taglineProps), {}, {
    children: "Support is not available for this app."
  }));
};
export default SupportTagline;